import React, { useState, useEffect } from "react";

const TESTIMONIALS_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_testimonials";
const TRUNCATE_LIMIT = 80;

function truncateAtWord(text, limit) {
  if (!text || text.length <= limit) return { short: text, isTruncated: false };
  const slice = text.slice(0, limit);
  const lastSpace = slice.lastIndexOf(" ");
  const short = lastSpace > 0 ? slice.slice(0, lastSpace) : slice;
  return { short, isTruncated: true };
}

const QuoteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path d="M10.8329 5C16.1566 5 19.9996 9.39508 19.9995 15.9027C19.9654 25.3579 12.8574 32.0431 2.60313 33.3269C1.65178 33.446 1.28495 32.1281 2.16102 31.7386C6.09567 29.989 8.08287 27.7689 8.33955 25.5714C8.53132 23.9296 7.63883 22.4915 6.51816 22.2222C3.61285 21.524 1.66627 17.906 1.66627 14.1667C1.66627 9.10406 5.77033 5 10.8329 5Z" fill="#D3A574" />
    <path d="M30.8329 5C36.1566 5 39.9996 9.39508 39.9995 15.9027C39.9654 25.3579 32.8574 32.0431 22.6031 33.3269C21.6518 33.446 21.2849 32.1281 22.161 31.7386C26.0957 29.989 28.0829 27.7689 28.3395 25.5714C28.5313 23.9296 27.6388 22.4915 26.5182 22.2222C23.6129 21.524 21.6663 17.906 21.6663 14.1667C21.6663 9.10406 25.7703 5 30.8329 5Z" fill="#D3A574" />
  </svg>
);

function TestimonialSection() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (id) =>
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));

  useEffect(() => {
    fetch(`${TESTIMONIALS_API}?page=1&limit=20`)
      .then((res) => res.json())
      .then((json) => {
        if (Array.isArray(json?.data)) {
          setTestimonials(json.data);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <section className="testimonial-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 align-items-end">
            <div className="col-12 col-sm-6">
              <div className="section-heading">
                <div className="sub-title">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  TESTIMONIAL
                </div>
                <h2>From Our Clients</h2>
              </div>
            </div>

            <div className="col-12 col-sm-6">
              <div className="swiper-navigation-container">
                <div className="testimonial-button-prev">
                  <i className="ti ti-arrow-left"></i>
                </div>
                <div className="testimonial-button-next">
                  <i className="ti ti-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="testimonial-slide">
                <div className="swiper testimonial-swiper">
                  <div className="swiper-wrapper">
                    {loading && (
                      <div className="swiper-slide">
                        <div
                          className="testimonial-card d-flex align-items-center justify-content-center"
                          style={{ minHeight: 180 }}
                        >
                          <span>Loading testimonials...</span>
                        </div>
                      </div>
                    )}
                    {!loading && testimonials.length === 0 && (
                      <div className="swiper-slide">
                        <div
                          className="testimonial-card d-flex align-items-center justify-content-center"
                          style={{ minHeight: 180 }}
                        >
                          <span>No testimonials yet.</span>
                        </div>
                      </div>
                    )}
                    {!loading &&
                      testimonials.map((t, i) => {
                        const { short, isTruncated } = truncateAtWord(t.testimonial, TRUNCATE_LIMIT);
                        const isExpanded = !!expanded[t.id];
                        return (
                          <div className="swiper-slide" key={t.id}>
                            <div className="testimonial-card">
                              <div
                                className="testimonial-thumbnail"
                                style={{
                                  backgroundImage: `url('assets/img/bg-img/${i % 2 === 0 ? "14" : "15"}.jpg')`,
                                }}
                              ></div>
                              <div className="testimonial-info">
                                <QuoteIcon />
                                <p className="testimonial-text">
                                  "{isExpanded || !isTruncated ? t.testimonial : short}"
                                  {isTruncated && (
                                    <button
                                      className="testimonial-more-link"
                                      onClick={() => toggleExpand(t.id)}
                                    >
                                      {isExpanded ? " less" : " more"}
                                    </button>
                                  )}
                                </p>
                                <p className="name mb-0">{t.client_name}</p>
                                {t.service_rendered && (
                                  <p className="designation mb-0">{t.service_rendered}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default TestimonialSection;
